const SETTING_DATA_TYPE_OPTIONS = [
    { label: "Text", value: "string" },
    { label: "Yes/No", value: "bool" },
    { label: "Integer", value: "int" },
    { label: "Decimal", value: "double" },
    //{ label: "JSON", value: "json" } //not set up to handle json yet
];

const getDisplayValue = (value, type) => {
    if (type === "bool") {
        return value ? "Yes" : "No";
    } else {
        return String(value);
    }

}

const parseValue = (value, dataType) => {
    switch (dataType) {
        case "string":
            return String(value);
        case "bool":
            return value === "true";
        case "int":
            return parseInt(value, 10);
        case "double":
            return parseFloat(value);
        case "json":
            return JSON.parse(value);
        default:
            return value;
    }
}

const stringifyValue = (value, dataType) => {
    if (dataType === "json") return JSON.stringify(value, null, 2);
    return String(value);
}

export {
    SETTING_DATA_TYPE_OPTIONS,
    getDisplayValue,
    parseValue,
    stringifyValue
};